export const en = {
  mainTitle: "Who drinks?",
  menu: {
    home: "Home",
    wheel: "Wheel of Shots",
    lottery: "Drunk Lottery",
    neverHave: "Never have I have",
    fingerSelector: "Bad picker",
    whereIsIt: "Where is it?",
    simon: "Simon duel",
    truthOrDrink: "Truth or Drink?",
    image: "WhoDrinks Logo",
  },
  mobileMenu: {
    home: "Home",
    wheel: "Wheel of Shots",
    lottery: "Drunk Lottery",
    neverHave: "Never have I have",
    fingerSelector: "Bad picker",
    whereIsIt: "Where is it?",
    simon: "Simon duel",
    truthOrDrink: "Truth or Drink?",
  },
  footer: {
    message: {
      firstPart: "Coded with",
      secondPart: "by MicroChanges.",
    },
  },
  modal: {
    title: "Awesome!! =)",
    description:
      "<b>{drawn}</b> was the winner of the round! Prepare a good shot of happiness for this lucky guy/girl!",
    notify:
      "{drawn} was the winner of the round! Prepare a good shot of happiness for this lucky guy/girl",
    closeButton: "Close",
  },
  socialFooter: {
    title: "Share",
  },
  home: {
    title: "Who drinks?",
    subtitle: "Let's have a drink!",
    image: "People drinking", 
    wheelButton: "Wheel of Shots",
    lotteryButton: "Drunk Lottery",
    neverHaveButton: "Never have I ever",
    fingerSelectorButton: "Bad picker",
    whereIsItButton: "Where is it?",
    simonButton: "Simon duel",
    truthOrDrink: "Truth or Drink?",
    description:
      "Hey, we would love to hear your thoughts on this. Please, click on the yellow button at the bottom of the screen and send us a message =)",
    installLabel: {
      firstPart: "Click",
      secondPart: "here",
      thirdPart: "to install the App!",
    },
    games: "Choose the game",
    howto: "How to play",
  },
  wheel: {
    mainPage: {
      title: "Who drinks?",
      wheelButton: "Spin Wheel!",
      renameLink: "Rename Slots",
      wheelSpaces: {},
      firstSlot: "Take a shot",
      secondSlot: "Dance a music",
      thirdSlot: "Pass the turn",
      fourthSlot: "Choose a friend to drink",
      fifthSlot: "Drink and spin another turn",
      sixthSlot: "Drink without using your hands",
      seventhSlot: "Drink twice",
      eighthSlot: "Everybody drinks except you",
    },
    renamePage: {
      inputLabel: "Participant or prize",
      inputPlaceholder: "Fill with a participant or a prize",
      saveButton: "Save",
    },
  },
  lottery: {
    mainPage: {
      title: "Who drinks?",
      subtitle: "Drawing next shot in:",
      configLink: "Change lottery configuration",
      tableHeader: "Participants",
      stopLotteryLink: "Stop lottery",
    },
    configPage: {
      title: "Who drinks?",
      subtitle: "Fill the lottery configuration",
      inputTimeLabel: "Time between lotteries (in minutes):",
      inputTimePlaceholder: "Fill with the time between the lotteries",
      inputMemberLabel: "Participants:",
      inputMemberPlaceholder: "Fill with a participant nickname",
      validateLotteryTime: "Lottery time is required",
      validateMemberList: "At least a participant is required",
      saveButton: "Save",
    },
  },
  neverHave: {
    title: "Who drinks?",
    initialPhrase: "Click in one of the buttons to draw a phrase.",
    gentleButton: "Gentle",
    controversyButton: "Controversy",
    embarrassingButton: "Embarrassing",
    spicyButton: "Spicy 18+",
  },
  truthOrDrink: {
    title: "Who drinks?",
    initialPhrase: "Click in one of the buttons to draw a phrase.",
    normalButton: "Normal question",
    partyButton: "Party question",
    dirtyButton: "Dirty question",
    intimateButton: "Intimate question",
  },
  fingerSelector: {
    title: "Who drinks?",
    centralMessage: {
      restart: "Press here to restart",
      pressScreen: "Press the screen",
      anotherFinger: "Another finger to start the count",
    },
  },
  simon: {
    nextRoundButton: "Next round",
    nextMatchButton: "Next match",
    startRoundButton: "Start next round",
    startMatchButton: "Start next match",
    matchWinner:
      "You win! Prepare a gorgeous shot of happiness for your opponent. =)",
    matchLoser:
      "You lose. In order to refresh your mind, take a gorgeous shot of happiness. =)",
    roundWinner:
      "Congratulations! You won this round! Prepare yourself to the next round.",
    roundLoser:
      "Sorry, you lost this round. Focus yourself to win the next round.",
    centralMessage: {
      go: "Go!",
    },
  },
  whereIsIt: {
    levels: {
      easy: "Easy",
      medium: "Medium",
      hard: "Hard",
      impossible: "Impossible",
    },
    guideMessage: {
      selectTheLevel: "Select the game mode",
      youWin: "You win! No sips this time =)",
      youLose: "You lose! Take a sip to refresh your mind =)",
    },
    restartButton: "Restart the game",
  },
  howToPlayBackDrop: {
    title: "How to Play",
    tips: {
      wheel: "This one is soft! Choose a drinker and hit the roulette wheel. The chosen one does what is chosen.",
      lottery: "Call the guys and let's see who is the luckiest. Fill in the form with the participants and the drawing time. Once the time is up, one of the participants will be drawn and will have to drink a big dose of alcohol.",    
      badPicker: "The chosen one! Just place more than one finger on the screen to start counting. At the end of the count, one of the fingers will be drawn for the round.",
      whereIsIt: "Are you good enough? Just select the difficulty for the game to start. Look for the empty glass and keep an eye on where it goes. The cups will shuffle for a while until they stop. If you hit the empty glass, congratulations! You made it through this round unscathed. But in case you miss... Take a nice shot =)",
      simon: "It's duel time! Challenge someone to play against you. When starting the game, the machine will choose a random sequence of colors. Wait for the counter to zero and make the exact same sequence of colors that the computer did to be the winner! Whoever wins two games first is the winner of the duel.",
      truthOrDrink: "This is to find out the truth. Select a question type and choose someone to answer. If the person doesn't want to answer, just take a delicious alcoholic drink. Easy right?",
    },
  },
  gamesBackdrop: {
    title: "Choose the game",
  },
};
